import { Modals } from '../../../shared/modals/Modals';
import React from 'react';
import { iDataUpdateModalProps } from '../../../model/app/Application';
import { useTranslation } from 'react-i18next';
export const CommissionerUpdateModal = ({
  selectedData,
  changeHandler,
  updateData,
}: iDataUpdateModalProps) => {
  const { t } = useTranslation();
  return (
    <Modals
      modalId="modaldemo1"
      title={`${t('Commissioner.commissioner')} - ID: ${selectedData?.id}`}
      body={
        <div className="form-group mb-0">
          <label htmlFor="exampleInputEmail1">{t('Commissioner.name')}</label>
          <input
            type="text"
            className="form-control updateModalField"
            name="name"
            key={selectedData?.name}
            defaultValue={selectedData?.name}
            onBlur={changeHandler}
            placeholder={t('Commissioner.enter_title')}
          />
        </div>
      }
      updateChanges={updateData!}
    />
  );
};
